import React from 'react';

import WidgetComponent from '../../widget/WidgetComponent';
import Widget from '../../widget/Widget';
import WidgetModal from '../../widget/WidgetModal';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class DemandTalents extends WidgetComponent
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {
            options:{
                'url':url,
                'records':5,
                'title':'招聘信息'
            },
            columns:[
                {name:'NAME', title:'招聘岗位', type:'string', properties:{"click":"recruitDetail"}},
                {name:'JOBADDR', title:'工作地点', type:'string'},
                {name:'SALARY', title:'薪资', type:'string'},
                {name:'UPDATETIME', title:'发布日期', type:'string'},
                {name:'HEADCNT', title:'招聘人数', type:'string', properties:{"hidden":true}},
                {name:'WORKINGYEAR', title:'工作年限', type:'string', properties:{"hidden":true}},
                {name:'EDU', title:'学历要求', type:'string', properties:{"hidden":true}},
                {name:'MAJOR', title:'专业要求', type:'string', properties:{"hidden":true}},
                {name:'FUNCTION', title:'职位职能', type:'string', properties:{"hidden":true}},
                {name:'DESCRIPTION', title:'职位描述', type:'string', properties:{"hidden":true}},
            ],
            params :{
                'service':'getRecruitmentInfo',
                'user':UID,
                'ENTNAME' : entname
            },
            recruitOptions:{
                name:"recruit",
                title:"招聘详情",
                size:"md",
            },
            recruitData:{
                NAME: "",
                HEADCNT: "",
                SALARY: "",
                WORKINGYEAR: "",
                EDU: "",
                MAJOR: "",
                JOBADDR: "",
                FUNCTION: "",
                UPDATETIME: "",
                DESCRIPTION: "",
            }

        };

        this.onLoadToken = this.onLoadToken.bind(this);
        this.notify = this.notify.bind(this);

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params } = this.state;
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
 
            this.setState({params:params}); 
        }
        else
        {
            return ;
        }  
    }

    onRef = (ref) => {

        if( ref.props.options.name === "recruit" )
        {
            this.recruitModal =  ref ;
        }
        
    }

    notify(type, data, value) 
    {
        switch( type )
        {
            case "recruitDetail":
            {
                let { recruitOptions } = this.state;

                recruitOptions["title"] = value;

                data = JSON.parse(data);
                
                this.setState({
                    recruitData:{
                        NAME:data.NAME,
                        HEADCNT: data.HEADCNT,
                        SALARY: data.SALARY,
                        WORKINGYEAR: data.WORKINGYEAR,
                        EDU: data.EDU,
                        MAJOR: data.MAJOR,
                        JOBADDR: data.JOBADDR,
                        FUNCTION: data.FUNCTION,
                        UPDATETIME: data.UPDATETIME,
                        DESCRIPTION: data.DESCRIPTION,
                    },
                    recruitOptions:recruitOptions
                })
                
                this.recruitModal.open();

                break;
            }
            default :
                break;
        }
    }

    render() 
	{

        const {options, columns, params, recruitOptions, recruitData } = this.state;
        
        return(
            <div className="page">
                <div className="page-content page-overflow height-100 white padding-20">
                    <div className="content-top">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} notify={this.notify}/>
                    </div>

                    {/* 招聘信息弹出框 */}
                    <WidgetModal options={recruitOptions} onRef={this.onRef}>
                        <div className="baseInfo">
                        <table>
				            <tbody id="show_data">
                                <tr>
                                    <td class="detail_td_1">职位名称</td>
                                    <td class="detail_td_2" id="">{recruitData.NAME}</td>
                                    <td class="detail_td_1">招聘人数</td>
                                    <td class="detail_td_2" id="">{recruitData.HEADCNT}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">薪水范围</td>
                                    <td class="detail_td_2" id="">{recruitData.SALARY}</td>
                                    <td class="detail_td_1">工作年限</td>
                                    <td class="detail_td_2" id="">{recruitData.WORKINGYEAR}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">学历要求</td>
                                    <td class="detail_td_2" id="">{recruitData.EDU}</td>
                                    <td class="detail_td_1">专业要求</td>
                                    <td class="detail_td_2" id="">{recruitData.MAJOR}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">工作地点</td>
                                    <td class="detail_td_2" id="">{recruitData.JOBADDR}</td>
                                    <td class="detail_td_1">职位职能</td>
                                    <td class="detail_td_2" id="">{recruitData.FUNCTION}</td>
                                </tr>
                                <tr>
                                    <td class="detail_td_1">职位刷新时间</td>
                                    <td class="detail_td_2" id="">{recruitData.UPDATETIME}</td>
                                    <td class="detail_td_1">职位描述</td>
                                    <td class="detail_td_2" id="">{recruitData.DESCRIPTION}</td>
                                </tr>
                            </tbody>
			            </table>
                        </div>
                    </WidgetModal>
                </div>
            </div>
        );
    }

}

export default DemandTalents